import React from 'react';

import { Typography } from '@mui/material';

import { Modal } from 'src/components/common';
import { EmployerStaffInviteModalForm } from 'src/components/employerStaff';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import { EmployerStaffInviteModalArgs } from './types';

export const EmployerStaffInviteModal: React.FC = () => {
  const { isOpen, closeModal, switchClosability, args } = useModal<EmployerStaffInviteModalArgs>(
    ModalId.EmployerAdminInviteStaffModal,
  );

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Invite Staff"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      headerPadding="32px 32px 4px"
      headerProps={{
        sx: {
          lineHeight: '28px',
        },
      }}
      contentProps={{
        sx: {
          pt: 0,
        },
      }}
    >
      <Typography color="GrayText" variant="body1" component="h4" mb={3}>
        Invite Staff by using their email address
      </Typography>
      <EmployerStaffInviteModalForm
        onCloseModal={onCloseModal}
        switchClosability={switchClosability}
        employerId={args?.employerId}
      />
    </Modal>
  );
};
